function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedTwinBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19.753c0-1.654 1.346-3 3-3h12c1.654 0 3 1.346 3 3V24H7v-4.247zM9 9c0-1.654 2.345-4 4-4h6c1.654 0 4 2.346 4 4v5.855c-.323-.067-1.067-.102-1-.102H10a4.92 4.92 0 00-1 .102V9zM7 29v-3h18v3h2v-9.247c0-1.627-.794-3.061-2-3.975V9c0-2.757-3.244-6-6-6h-6c-2.758 0-6 3.243-6 6v6.778c-1.207.914-2 2.348-2 3.975V29h2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10h4a3 3 0 110 6h-4a3 3 0 010-6zm0 2a1 1 0 100 2h4a1 1 0 000-2h-4z",
    fill: props.color
  }));
}

export default SvgIconBedTwinBedFilled;